import { supabase as integratedClient } from '@/integrations/supabase/client';

// Re-export the configured Supabase client
export const supabase = integratedClient;

// Local types used by the app UI
export type Property = {
  id: string
  title: string
  address: string
  city: string
  type: string
  surface_area?: number
  rental_price?: number
  status?: string
  // Support both legacy and DB field names
  available_from?: string | null
  availability_date?: string | null
  summary?: string | null
  description?: string | null
  amenities?: string[] | null
  photos?: string[] | null
  contact_person?: string | null
  created_at?: string
  updated_at?: string
}

export type Project = {
  id: string
  title: string
  city: string
  status?: string
  // Support both legacy and DB field names
  photo?: string | null
  main_photo_url?: string | null
  description?: string | null
  highlights?: string[] | null
  gallery?: string[] | null
  gallery_urls?: string[] | null
  created_at?: string
  updated_at?: string
}

